import ObjectUtils from '../utils/ObjectUtils';

export default class MetaController
{

	defaultMeta:MetaItem;
	metas = {};

	constructor(data:object)
	{
		this._parseData(data);
	}

	private getMeta(path)
	{
		return
	}

	private _mergeMeta(path)
	{
		let metas = [];
		let meta:MetaItem;

		do{
			if((meta = this.metas[path]))
			{
				metas.push(meta);
			}
		}while((path = path.replace(/[^\/]*\/?$/, '')).length > 0)

		metas = metas.reverse();

		let data, data2;
		metas.forEach((e) => {
			data2 = e.data;
			if(!data){
				data = Object.assign([], data2);
			}else
			{
				for(let [k, v] of Object.entries(data))
				{
					if(typeof v == 'object')
					{
						if(data2[k])
						{
							data[k] = Object.assign(data[k], ObjectUtils.filter(data2[k], Object.keys(data[k])));
						}
					}else if(k in data2){
						data[k] = data2[k];

					}
				}
			}
		});
		return data;
	}

	private _sortPaths(a:string, b:string):number
	{
		let pa = a.split('/').length;
		let pb = b.split('/').length;
		let la = a.length;
		let lb = b.length;
		if(pa > pb) return 1;
		if(pb < pa) return -1;
		if(la > lb) return 1;
		if(la < lb) return -1;
		return 0;
	}

	private _parseData(routeData)
	{
		this._parseRoutes(routeData);
		let paths = Object.keys(this.metas);
		paths = paths.sort(this._sortPaths);
		paths.forEach((path) => {
			this.metas[path].data = this._mergeMeta(path)
		});
	}

	private _parseRoutes(routeData, parentPath = '')
	{
		if(!routeData['routes']) return;
	
		let pages = [];
		let reverse = true;

		for (let [path, data] of Object.entries(routeData['routes']))
		{
			path = '/' + parentPath + '/' + path + '/';
			path = path.replace(/\/+/g, '/');
			let meta = new MetaItem(path, data['meta'])
			if(!this.metas[path] || (this.metas[path] && this.metas[path].size() < meta.size()))
			{
				this.metas[path] = meta;
			}

			this._parseRoutes(data, path);
		}
	}

	updateMeta(path:string)
	{
		let meta;
		if((meta = this.metas[path]))
		{
			if('title' in meta.data)
			{
				let title = document.querySelector('title');
				if(!title){
					title = document.createElement('title')
					document.querySelector('head').appendChild(title);
				}
				title.innerHTML = meta.data.title;
			}
		}
	}
}

class MetaItem
{
	path:string;
	data:object;
	constructor(path:string, data:object = {})
	{
		path = ('/' + path + '/').replace(/\/+/g, '/');
		this.path = path;
		this.data = data;
	}

	size()
	{
		return JSON.stringify(this.data).length;
	}
}